import { render } from "./LayoutCard.vue?vue&type=template&id=737f2e8d"
import script from "./LayoutCard.vue?vue&type=script&lang=js"
export * from "./LayoutCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__